module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"product":"produit | produits"},"en":{"product":"product | products"},"de":{"product":"Produkte | Produkte"},"es":{"product":"producto | productos"},"it":{"product":"prodotto | prodotti"},"nl":{"product":"product | producten"},"pt":{"product":"produto | produtos"}}')
  delete Component.options._Ctor
}
